 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useLazyLoadQuery} from 'react-relay'


import JiraScopingSearchFilterMenu from './JiraScopingSearchFilterMenu'

const query = graphql`
  query JiraServerScopingSearchFilterMenuRootQuery($teamId: ID!, $meetingId: ID!) {
    viewer {
      meeting(meetingId: $meetingId) {
        id
        ... on PokerMeeting {
          jiraServerSearchQuery {
            projectKeyFilters
            isJQL
          }
        }
      }
      teamMember(teamId: $teamId) {
        integrations {
          jiraServer {
            projects {
              id
              name
              avatar
            }
          }
        }
      }
    }
  }
`







const JiraServerScopingSearchFilterMenuRoot = (props) => {
  const {menuProps, teamId, meetingId} = props

  const data = useLazyLoadQuery(
    query,
    {
      teamId,
      meetingId
    },
    {
      fetchPolicy: 'store-or-network'
    }
  )

  const projects = _nullishCoalesce(_optionalChain([data, 'optionalAccess', _ => _.viewer, 'access', _2 => _2.teamMember, 'optionalAccess', _3 => _3.integrations, 'access', _4 => _4.jiraServer, 'optionalAccess', _5 => _5.projects]), () => ( []))
  const jiraSearchQuery = _nullishCoalesce(_optionalChain([data, 'optionalAccess', _6 => _6.viewer, 'access', _7 => _7.meeting, 'optionalAccess', _8 => _8.jiraServerSearchQuery]), () => ( null))

  return (
    React.createElement(JiraScopingSearchFilterMenu, {
      meetingId: meetingId,
      jiraSearchQuery: jiraSearchQuery,
      projects: projects,
      menuProps: menuProps,
      service: "jiraServer",}
    )
  )
}

export default JiraServerScopingSearchFilterMenuRoot
